"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("antd/lib/spin/style");
var _spin = _interopRequireDefault(require("antd/lib/spin"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _utils = require("../../../utils");
var _components = require("../../../components");
var _EmergencyContact = _interopRequireDefault(require("./EmergencyContact"));
var _PatientInfoCard = require("../PatientInfoCard");
var _EmergencyContactsListEditor = _interopRequireDefault(require("../../EmergencyContactsListEditor"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var EmergencyContacts = function EmergencyContacts(props) {
  var patientId = props.patientId,
    _props$emptyText = props.emptyText,
    emptyText = _props$emptyText === void 0 ? 'No emergency contacts for this patient.' : _props$emptyText;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    editorActive = _useState2[0],
    setEditorActive = _useState2[1];
  var _useFetch = (0, _utils.useFetch)((0, _utils.getPatientEmergencyContactsUrl)(patientId), [], !!patientId && !editorActive),
    contacts = _useFetch.data,
    loading = _useFetch.loading,
    refetchEmergencyContacts = _useFetch.refetch;
  var handleToggleEditor = function handleToggleEditor() {
    if (editorActive) {
      refetchEmergencyContacts();
    }
    setEditorActive(function (prevEditorActive) {
      return !prevEditorActive;
    });
  };
  return /*#__PURE__*/_react.default.createElement(_spin.default, {
    spinning: loading,
    size: "large"
  }, /*#__PURE__*/_react.default.createElement(_PatientInfoCard.PatientInfoCard, {
    title: "Emergency Contacts",
    actionContent: /*#__PURE__*/_react.default.createElement(_components.Icon, {
      type: "edit-pencil",
      className: "cursor-pointer",
      onClick: handleToggleEditor
    })
  }, editorActive ? /*#__PURE__*/_react.default.createElement("div", {
    className: "emergency-contact-wrapper"
  }, /*#__PURE__*/_react.default.createElement(_EmergencyContactsListEditor.default, {
    patientId: patientId,
    onEdited: handleToggleEditor
  })) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !contacts.length ? emptyText : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, contacts.map(function (contact, index) {
    return /*#__PURE__*/_react.default.createElement(_EmergencyContact.default, {
      key: contact.id,
      contact: contact,
      showDivider: index > 0
    });
  })))));
};
var _default = EmergencyContacts;
exports.default = _default;
EmergencyContacts.propTypes = {
  patientId: _propTypes.default.string,
  title: _propTypes.default.string,
  loading: _propTypes.default.bool,
  emptyText: _propTypes.default.string
};